import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-voucher-active-dialog',
    templateUrl: './voucher-active-dialog.component.html',
    styleUrls: ['./voucher-active-dialog.component.scss'],
    standalone: false
})
export class VoucherActiveDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
